/**
 * DoctorProfilePage.jsx
 *
 * Doctor Public Profile management page.
 * Route: /org/profile
 *
 * STATUS: Coming Soon — full implementation ready but gated.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../theme/ThemeContext';
import { ROUTES } from '../constants/routes';
import ChatLogo from '../components/common/ChatHeader/ChatLogo';
import ThemeToggleButton from '../components/common/ChatHeader/ThemeToggleButton';
import { UserProfilePanel } from '../components/common/UserProfile';

export default function DoctorProfilePage() {
  const navigate = useNavigate();
  const { isDark } = useTheme();

  const bg = isDark ? '#0f0f11' : '#f5f5f7';
  const cardBg = isDark ? 'rgba(255,255,255,0.03)' : '#fff';
  const border = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)';
  const textPrimary = isDark ? '#f5f5f7' : '#111827';
  const textSecondary = isDark ? '#9ca3af' : '#6b7280';
  const inputBorder = isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)';

  return (
    <div style={{ minHeight: '100vh', background: bg }}>
      {/* ── Header ── */}
      <header style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0.75rem 1.5rem',
        borderBottom: `1px solid ${border}`,
        background: cardBg,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <ChatLogo size={28} />
          <h1 style={{ margin: 0, fontSize: '1rem', fontWeight: 600, color: textPrimary }}>
            Doctor Public Profile
          </h1>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <ThemeToggleButton />
          <UserProfilePanel />
          <button
            onClick={() => navigate(ROUTES.ORG)}
            style={{
              padding: '0.375rem 0.75rem',
              borderRadius: '0.5rem',
              border: `1px solid ${inputBorder}`,
              background: 'none',
              color: textSecondary,
              fontSize: '0.75rem',
              cursor: 'pointer',
            }}
          >
            ← Back
          </button>
        </div>
      </header>

      {/* ── Coming Soon ── */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 4rem)',
      }}>
        <div style={{
          textAlign: 'center',
          maxWidth: '420px',
          padding: '3rem 2rem',
          borderRadius: '1.25rem',
          background: cardBg,
          border: `1px solid ${border}`,
          boxShadow: isDark ? '0 8px 32px rgba(0,0,0,0.3)' : '0 8px 32px rgba(0,0,0,0.06)',
        }}>
          <span style={{ fontSize: '3.5rem', display: 'block', marginBottom: '1rem' }}>🪪</span>
          <h2 style={{
            margin: '0 0 0.5rem',
            fontSize: '1.5rem',
            fontWeight: 700,
            color: textPrimary,
          }}>
            Doctor Public Profile
          </h2>
          <p style={{
            margin: '0 0 0.25rem',
            fontSize: '1rem',
            fontWeight: 600,
            background: 'linear-gradient(135deg, #0891b2, #06b6d4)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>
            Coming Soon
          </p>
          <p style={{
            margin: '0 0 1.5rem',
            fontSize: '0.8125rem',
            color: textSecondary,
            lineHeight: 1.5,
          }}>
            Manage your public profile — display name, photo, qualification,
            department &amp; more.
          </p>
          <button
            onClick={() => navigate(ROUTES.ORG)}
            style={{
              padding: '0.5rem 1.25rem',
              borderRadius: '0.5rem',
              border: 'none',
              background: 'linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)',
              color: '#fff',
              fontSize: '0.8125rem',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            ← Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
